<!-- eslint-disable @angular-eslint/template/cyclomatic-complexity -->
<div class="m-widget4__item hover-to-show document-element w-100 d-flex mb-1 p-1 rowItem">
    <div (click)="clickRow()" class="w-100 dropDownItem ml-1">
        <div class="m-widget4__info">
            <span class="m-widget4__text">
                <ng-container *ngIf="data?.customName; else onlyType">
                    {{ data.customName }}
                    <small>&nbsp;({{ data?.paperType | paperName }})</small>
                </ng-container>
                <ng-template #onlyType>
                    {{ data?.paperType | paperName }}
                </ng-template>
            </span>
            <span *ngIf="data?.signedPaper || data?.shared" class="mt-2 m-widget4__text float-right">
                <span *ngIf="data?.signedPaper" ngbTooltip="Podpisana listina"><i class="la la-shield"></i></span>
                <span *ngIf="data?.shared" [ngbTooltip]="tooltipText"><i class="la la-eye"></i></span>
                <span *ngIf="data?.crppShared" ngbTooltip="Listina deljena v CRPP"><i class="la la-book"></i></span>
            </span>
            <br />
            <small *ngIf="type === pfType.TERM">
                <ng-container *ngIf="data?.created; else termElse">
                    <b>{{ data?.created | date: 'dd.MM.yyyy HH:mm' }}</b>
                </ng-container>
                <ng-template #termElse>
                    <b>{{ data?.paperDate | date: 'dd.MM.yyyy HH:mm' }}</b>
                </ng-template>
            </small>
            <small *ngIf="type === pfType.CUSTOMER">
                <ng-container *ngIf="data?.visitDate; else templateName">
                    <b>{{ data?.visitDate | date: 'dd.MM.yyyy HH:mm' }}</b>
                </ng-container>
                <ng-template #templateName>
                    <b>{{ data?.paperDate | date: 'dd.MM.yyyy HH:mm' }}</b>
                    <ng-container *ngIf="data?.paperType == paperType.SURVEY_CUSTOMER">
                        <i class="la la-user"></i>
                    </ng-container>
                </ng-template>
            </small>
            <small *ngIf="type === pfType.PUBLIC">
                <ng-container>
                    <b>Ustvarjeno: {{ data?.created | date: 'dd.MM.yyyy' }}</b>
                </ng-container>
            </small>
            <div *ngIf="showCreationLocation" class="m-badge m-badge--metal m-badge--wide ml-1"></div>
        </div>
    </div>
    <div class="m-widget4__ext mf-t-editDocument">
        <div
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            class="btn m-btn m-btn--icon m-btn--icon-only m-btn--pill popup-to-show"
        >
            <i class="la la-ellipsis-v"></i>
        </div>
        <div *ngIf="type === pfType.TERM" class="dropdown-menu">
            <!-- pogled rezervacija/obravnava -->
            <div (click)="print()" class="dropdown-item dropDownItem">Tiskaj</div>
            <div *ngIf="!data?.shared" (click)="send()" class="dropdown-item dropDownItem">Pošlji</div>
            <div *ngIf="data?.shared" (click)="stopSharing()" class="dropdown-item dropDownItem">Prekliči deljenje</div>
            <ng-container *ngIf="canSendToCrpp">
                <div (click)="sendCRPP()" class="dropdown-item dropDownItem">Pošlji v CRPP</div>
            </ng-container>
            <ng-container *ngIf="canCancelCrppShare">
                <div (click)="cancelCRPPShare()" class="dropdown-item dropDownItem">Prekliči deljenje v CRPP</div>
            </ng-container>
            <div
                *ngIf="
                    termData?.telemed &&
                    (termData.reservationType == reservationType.HDP ||
                        termData.reservationType == reservationType.HDD ||
                        termData.reservationType == reservationType.SAVAD ||
                        termData.reservationType == reservationType.SAVAP ||
                        termData.reservationType == reservationType.MDFTP ||
                        termData.reservationType == reservationType.WIDGET_VOUCHER ||
                        termData.reservationType == reservationType.MDFTD)
                "
                (click)="attachToHdChat()"
                class="dropdown-item dropDownItem"
            >
                Dodaj na ePosvet klepet
            </div>
            <div (click)="preview()" class="dropdown-item dropDownItem">Predogled</div>
            <div *ngIf="isOccupationalMedicineActive" (click)="mergeWithDocument()" class="dropdown-item dropDownItem">Poveži dokument</div>
            <div (click)="renamePortfolioPaper()" class="dropdown-item dropDownItem">Preimenuj</div>
        </div>
        <div *ngIf="type === pfType.CUSTOMER" class="dropdown-menu">
            <!-- pregled listin na  stranki -->
            <div *ngIf="!data?.shared" (click)="send()" class="dropdown-item dropDownItem">Pošlji</div>
            <div *ngIf="data?.shared" (click)="stopSharing()" class="dropdown-item dropDownItem">Prekliči deljenje</div>
            <div (click)="preview()" class="dropdown-item dropDownItem">Predogled</div>
            <div (click)="redirectVisitOrReservation()" class="dropdown-item dropDownItem">
                <span *ngIf="data?.visitId; else reservation">Pojdi na obravnavo</span>
                <ng-template #reservation>Pojdi na rezervacijo</ng-template>
            </div>
            <div (click)="renamePortfolioPaper()" class="dropdown-item dropDownItem">Preimenuj</div>
        </div>
        <div *ngIf="type === pfType.PUBLIC" class="dropdown-menu">
            <!-- public domena ogled dokumentov -->
            <div (click)="print()" class="dropdown-item dropDownItem">Tiskaj</div>
            <div (click)="preview()" class="dropdown-item dropDownItem">Predogled</div>
        </div>
    </div>
</div>
